import React from "react";
import { Link } from "react-router-dom";

// single service
export function ServiceItem({ icon, title, desc }) {
  return (
    <div className="col-xl-3 col-md-6">
      <div className="tp-service text-center white-bg pt-60 pb-45 pl-25 pr-25 mb-30">
        <div className="tp-service__icon">
          <i className={icon}></i>
        </div>
        <h3 className="tp-service__title pt-40 pb-25">
          <Link to="/service-details">{title}</Link>
        </h3>
        <p>{desc}</p>        
      </div>
    </div>
  );
}

const Services = () => {
  return (
    <>
      {/* <!-- service area start  --> */}
      <div className="tp-service-ara grey-bg-4 pt-140 pb-140">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="tp-section-wrapper text-center mb-70">
                <span className="tp-section-subtitle mb-25">MOTIVES</span>
              </div>
            </div>
          </div>
          <div className="row">
            <ServiceItem
              icon="pe-7s-arc"
              title="Mission"
              desc="To harness the power of technology and innovation to create effective information and entertainment solutions."
            />
            <ServiceItem
              icon="pe-7s-cloud-download"
              title="Vission"
              desc="To become the leading Pan African VAS Company."
            />
            <ServiceItem
              icon="pe-7s-disk"
              title="Core Values"
              desc="• Innovation
                    • Employee satisfaction
                    • Customer satisfaction"
            />
            <ServiceItem
              icon="pe-7s-hammer"
              title="Our Purpose"
              desc="To add value to peoples' lives using the mobile phone through corporate solutions and services to individual consumers. "
            />           
          </div>
        </div>
      </div>
      {/* <!-- service area end  -->   */}
    </>
  );
};

export default Services;
